<template>
    <layout>
        <rdkm-title>
            {{ $t('Действия') }}
            <router-link tag="span" to="/actions/add">
                <b-button class="float-right" right size="sm" variant="primary">
                    <font-awesome-icon icon="plus" /> {{ $t('Добавить') }}
                </b-button>
            </router-link>
        </rdkm-title>
        <div class="tile">            
            <rdkm-grid ref="grid" :state="query">
                <grid-column name="code" cell="edit-cell" :title="$t('Код')" width="120"></grid-column>
                <grid-column name="name" :title="$t('Название')"></grid-column>
                <grid-column name="serviceCode" :title="$t('Код услуги')"></grid-column>
                <grid-column name="serviceName" :title="$t('Название услуги')"></grid-column>
                <grid-column name="section" :title="$t('Раздел')"></grid-column>
                <grid-column name="active" :title="$t('Действующая')"></grid-column>                  
                <grid-column name="DELETE" cell="delete-cell"></grid-column>              
            </rdkm-grid>
        </div>
    </layout>
</template>

<script>
import Grid from "../../components/grid/Grid.vue";
import GridColumn from "../../components/grid/GridColumn.vue";

export default {
  name: "Actions",
  props: ["query"],
  components: {
    "rdkm-grid": Grid,
    "grid-column": GridColumn
  }
};
</script>
